export default __webpack_public_path__ + "static/2014-asa-at-a8615adb16bda5835e561d8026e55851.pdf";